export class HtmlBuilder {
  constructor(ids, classes, content) {
    this.ids = ids
    this.classes = classes
    this.content = content
    console.log(this.ids, this.classes, this.content)
  }

  build() {
    return `<wfs-modal
      name="${this.content.name}"
      ${this.getAttributes()}
      id="${this.ids.id}"
      container-classes="wf-absolute wf-z-50 wf-h-max wf-max-w-full wf-overflow-hidden ${this.classes.containerClasses}"
    >${this.getInnerSections()}</wfs-modal>`
  }

  getAttributes() {
    let attributes = ''
    if (this.content.openOnLeave) {
      attributes+= ' open-on-leave'
    }
    if (this.content.timeOut) {
      attributes+= ` time-out="${this.content.timeOutTime}"`
    }
    return attributes
  }

  getInnerSections() {
    return this.content.sections.map(section => section.html).join('')
  }
}